enum FourOptions {
    NotSet = 0,
    Yes = 1,
    No = 2,
    Unknown = 3,
    NotConcern = 4,
  }
  
  export default FourOptions;